import {
  FaChevronDown,
  FaRegEdit,
  FaSave,
  FaDiceD6,
  FaUsersCog,
} from "react-icons/fa";
import { AiFillDelete, AiFillFlag, AiOutlineTransaction } from "react-icons/ai";
import { IoMdSend } from "react-icons/io";
import { BsImage, BsCheckCircle } from "react-icons/bs";
import { ImBlocked } from "react-icons/im";
import { SiAdblock } from "react-icons/si";
import { RxCross2 } from "react-icons/rx";
import { GrStatusGoodSmall } from "react-icons/gr";
import { FcProcess } from "react-icons/fc";
import { MdCancel } from "react-icons/md";
import { IoIosAddCircle } from "react-icons/io";
import { TbDeviceGamepad } from "react-icons/tb";
import { RiLockPasswordFill } from "react-icons/ri";

const ChevronIcon = FaChevronDown;
const TrashIcon = AiFillDelete;
const SendIcon = IoMdSend;
const EditIcon = FaRegEdit;
const ImageIcon = BsImage;
const BlockIcon = ImBlocked;
const UnBlockIcon = SiAdblock;
const CrossIcon = RxCross2;
const CheckCircleIcon = BsCheckCircle;
const StatusIcon = GrStatusGoodSmall;
const ProcessIcon = FcProcess;
const CancelIcon = MdCancel;
const SaveIcon = FaSave;
const AddCircleIcon = IoIosAddCircle;
const FlagIcon = AiFillFlag;
const RoomIcon = FaDiceD6;
const GameIcon = TbDeviceGamepad;
const UsersIcon = FaUsersCog;
const TransactionIcon = AiOutlineTransaction;
const PasswordIcon = RiLockPasswordFill;

export {
  ChevronIcon,
  TrashIcon,
  SendIcon,
  EditIcon,
  ImageIcon,
  BlockIcon,
  UnBlockIcon,
  CrossIcon,
  CheckCircleIcon,
  StatusIcon,
  ProcessIcon,
  CancelIcon,
  AddCircleIcon,
  SaveIcon,
  FlagIcon,
  RoomIcon,
  GameIcon,
  UsersIcon,
  TransactionIcon,
  PasswordIcon,
};
